const LocationsTable = require("../../src/client-ts/containers/Estimation/ComponentLocations/LocationsTable")
  .LocationsTable;

exports.locationsTable = LocationsTable;
